module.exports = __webpack_public_path__ + "img/clyh.ff58e9dc.svg";